import styled, { createGlobalStyle } from 'styled-components';
import { Scrollbar } from '@ann/web-components';

export const NextBestActionModalGlobalStyles = createGlobalStyle`
  .next-best-action-modal {
    z-index: 9999 !important;
  }
  .next-best-action-modal > div {
    max-height: 500px !important;
    height: 500px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

export const ModalBodyScroll = styled(Scrollbar).attrs({
  size: 'small',
  display: 'flex',
})`
  padding-right: 8px !important;
  & > span {
    max-height: 370px !important;
  }
`;
